const GetGatewaySchedulerLogs = 
  `query Query($count: Int, $cursor: String, $filterConfig: GatewaySchedulerFilterConfigInput) {
    gatewaySchedulerLogs(first: $count, after: $cursor, filterConfig: $filterConfig) {
      pageInfo {
        hasNextPage 
      }
      edges {
        cursor
        node {
          id
          failed
          region
          timestamp
          pollingInterval
        }
      }
    }
  }  
  `

const GetGatewaySchedulerLog = 
  `query Query($id: String!) {
    gatewaySchedulerLog(id: $id) {
      id
      businessLog {
        type
        message
        timestamp
      }
      failed
      region
      timestamp
      pollingInterval
    }
  }
  `

module.exports = {
  GetGatewaySchedulerLog,
  GetGatewaySchedulerLogs,
}
